import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPasskeys(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 8.425a5.4 5.4 0 0 0-1-.092c-2.23 0-3.962 1.312-4.803 3.226-.472 1.074.48 2.108 1.653 2.108h4.817m1-9.334a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0m-.334 5a1.667 1.667 0 1 1 2.334 1.528v.806l-.334.5.334.5v.666L12 14l-.667-.667v-2.472c-.588-.257-1-.844-1-1.528"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPasskeys);
export default ForwardRef;
